var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button",class:{
    'button--outline': _vm.outline,
    'button--text': _vm.text,
    'button--cta': _vm.cta,
    'button--dotted': _vm.dotted,
    'button--icon': !_vm.hasSlot,
    'button--compressed': _vm.compressed
  },attrs:{"disabled":!!_vm.disabled}},Object.assign({}, _vm.$listeners, {click: function (event) { return _vm.onClick(event); }})),[_c('span',{staticClass:"ripple",class:{
      'ripple--dark': _vm.outline,
      'ripple--light': !_vm.outline && !_vm.text && !_vm.cta && !_vm.dotted
    }}),_vm._v(" "),(_vm.badge)?_c('span',{staticClass:"badge",domProps:{"textContent":_vm._s(_vm.badge)}}):_vm._e(),_vm._v(" "),(_vm.hasIcon)?_c(_vm.icon,{tag:"component",staticClass:"icon"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }